/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

function parseValueToPx(value) {
  if (typeof value === "number") return "".concat(value, "px");
  return value;
}

export { parseValueToPx };
//# sourceMappingURL=utils.js.map
